import React, { useCallback, useEffect, useMemo, useState } from "react";
import { maybeWithAuth, urlB64ToUint8Array, webPushUrl } from "../app/utils";
import { useParams } from "react-router-dom";
import api from "../app/Api";
import { fetchOrThrow } from "../app/errors";
import config from "../app/config";

function SubscribeReceiver() {
  return <PushSubscriptionButton />;
}

function PushSubscriptionButton() {
  // const { token } = useParams();
  const { externalId } = useParams();
  const { topic } = useParams();
  const [token] = useState(
    "ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SnBZWFFpT2pFM05EazNNalUxTVRFc0luUnZhMlZ1SWpvaWMzVmlYM0U0YW1vNGNUZHpibXBpYkdweWNHNXJibmwxWnpVd2JERTVaemtpTENKamNtVmhkR1ZrWDJGMElqb2lJaXdpWlhoMFpYSnVZV3hmYVdRaU9pSXhOakU0WTJObE55MDVaREZsTFRReFltRXRPVFJrWWkwelpqQTNZemd4TWpSaU9XVWlmUS5DNVpaTWNkTkFpNDdrRE1NUXlJOTNsVllicXJzZ1Z6WThSNzA3TjJ1U1VN"
  );
  const [status, setStatus] = useState("enable");
  const [errorText, setErrorText] = useState("");

  const serializedRegData = async () => {
    const registration = await navigator.serviceWorker.register("/sw.js");
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(config.web_push_public_key),
    });
    console.log("Push subscription:", subscription);
    const serializedSubscription = JSON.parse(JSON.stringify(subscription));
    return serializedSubscription;
  };

  const subscriptionStatus = useCallback(async () => {
    try {
      let tp = [];
      if (topic && typeof topic == "string") {
        tp.push(topic);
      } else {
        tp.push("general");
      }
      const serializedSubscription = await serializedRegData();
      const statusRes = await fetchOrThrow(`${config.base_url}/v1/subscribers/status?sub=${token}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          endpoint: serializedSubscription.endpoint,
          auth: serializedSubscription.keys.auth,
          p256dh: serializedSubscription.keys.p256dh,
          topics: tp,
          // topics: ["general", topic],
          external_id: externalId,
          status,
        }),
      });
      return statusRes.json();
    } catch (error) {
      console.log(error);
      setErrorText(error.toString());
      return false;
    }
  }, []);

  async function subscribeToPush() {
    if (!("serviceWorker" in navigator)) {
      alert("Service workers are not supported by your browser.");
      return;
    }

    const registration = await navigator.serviceWorker.register("/sw.js");
    // const registration = await (async () => {
    //   let registration = null;
    //   registration = await navigator.serviceWorker.getRegistration();
    //   if (!registration) {
    //     registration = await navigator.serviceWorker.register(`/sw.js`);
    //   }
    //   if (!registration) {
    //     throw new Error("No service worker registration found");
    //   }
    //   console.log(" [SERVICE WORKER REGISTRATION EXIST]", registration);
    //   return registration;
    // })();
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      // Show your own UI explaining how to enable it manually
      alert("Notifications are disabled. Please enable them in your browser settings to continue.");
      return;
    }
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(config.web_push_public_key),
    });

    try {
      const serializedSubscription = JSON.parse(JSON.stringify(subscription));
      let tp = [];
      if (topic && typeof topic == "string") {
        tp.push(topic);
      } else {
        tp.push("general");
      }
      await fetchOrThrow(`${config.base_url}/v1/subscribers/enable?sub=${token}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          endpoint: serializedSubscription.endpoint,
          auth: serializedSubscription.keys.auth,
          p256dh: serializedSubscription.keys.p256dh,
          topics: tp,
          // topics: ["general", topic],
          external_id: externalId,
          status,
        }),
      });

      if (status == "enable") {
        setStatus("disable");
      }
      if (status == "disable") {
        setStatus("enable");
      }
    } catch (error) {
      setErrorText(error.toString());
      console.log(error);
    }
  }

  useEffect(() => {
    subscriptionStatus()
      .then((ss) => {
        console.log(ss, "this is the ss from the server");
        if (ss == true) {
          setStatus("disable");
        } else {
          setStatus("enable");
        }
      })
      .catch((err) => {
        console.log(err, "Sub Error ");
      });
  }, []);
  useEffect(() => {
    Notification.requestPermission().then((p) => {
      console.log(p, "THE PERMISSINO");
      if (p !== "granted") {
        alert("Please enable notification");
        return;
      }
    });
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
        padding: "0 20px",
      }}
    >
      <p style={{ maxWidth: "500px", fontSize: "16px", color: "red", marginBottom: "30px" }}>{errorText}</p>
      <h2 style={{ fontSize: "24px", marginBottom: "10px" }}>Stay Updated!</h2>
      <p style={{ maxWidth: "500px", fontSize: "16px", color: "#555", marginBottom: "30px" }}>
        Subscribe to push notifications to receive real-time updates, alerts, and important announcements directly in your browser — no need
        to keep this page open.
      </p>

      <button
        onClick={subscribeToPush}
        style={{
          padding: "14px 28px",
          fontSize: "16px",
          backgroundColor: status == "enable" ? "#1a73e8" : "#e88f1a",
          // backgroundColor: "#1a73e8",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          cursor: "pointer",
          transition: "background-color 0.3s ease",
        }}
      >
        {status == "enable" ? "Enable Push Notifications" : "Disable Push Notifications"}
      </button>
    </div>
  );
}

export default SubscribeReceiver;
